$(document).ready(function () {
  $('.js-nav-bt').on('click', function () {
    if ($('.js-nav-content').hasClass('is-navOn')) {
      $(".js-nav-content").removeClass('is-navOn');
      $(".js-header-logo-sp").removeClass('is-navOn');
      $(this).removeClass('is-navOn');
    } else {
      $(".js-nav-content").addClass('is-navOn');
      $(".js-header-logo-sp").addClass('is-navOn');
      $(this).addClass('is-navOn');
    }
  });
  $('.js-nav-bt.is-navOn, .js-nav-link').on('click', function () {
    $(".js-nav-content.is-navOn, .js-nav-bt.is-navOn").removeClass('is-navOn');
  });
});

$('a.is-linkNone').click(function () {
  return false;
});

if (window.matchMedia('(max-width: 1024px)').matches) {
  $(function () {
    $('.is-linkNone').on('click', function () {
      $(this).next().slideToggle();
      $(this).toggleClass('is-pulOn');
    });
  });
}

$('a[href^="#"]').on('click', function () {
  const speed = 800;
  const easing = 'swing';
  const href = $(this).attr('href');
  const target = $(href == '#' || href == '' ? 'html' : href);
  const spt = parseInt($('html').css('scrollPaddingTop')) || 0;
  const smt = parseInt($(target).css('scrollMarginTop')) || 0;
  const position = target.offset().top - (spt + smt);
  $('html, body').animate({ scrollTop: position }, speed, easing);
  return false;
});

$(function () {
  $(window).on('load scroll', function() {
    var scrollPos = $(this).scrollTop();
    if ( scrollPos > 100 ) {
      $('.js-header').addClass('is-changeOn');
    } else {
      $('.js-header').removeClass('is-changeOn');
    }
  });
});

const yearElm =  document.querySelector('.thisYear');
const thisYear = new Date().getFullYear();
yearElm.innerHTML = thisYear;

jQuery(function($) {
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });
});
